module.exports = __webpack_public_path__ + "media/tip_tier_1-0ba101a5b048a636e730f9efc5b34503.mp3";